module.exports = __webpack_public_path__ + "img/sld_dcdb.77a3bbf8.svg";